/** Shared primitive types used across client and server. */
/**
 * RESOLUTION 6 - Resource naming.
 * The canonical key is `wood` everywhere in code, API payloads and storage.
 * "Timber" is a *display label only* (see RESOURCE_META.wood.displayName).
 */
export const ResourceKey = {
    WOOD: 'wood',
    CLAY: 'clay',
    IRON: 'iron',
    GRAIN: 'grain',
};
export const RESOURCE_KEYS = [
    ResourceKey.WOOD,
    ResourceKey.CLAY,
    ResourceKey.IRON,
    ResourceKey.GRAIN,
];
export function emptyResources() {
    return { wood: 0, clay: 0, iron: 0, grain: 0 };
}
export function addResources(a, b) {
    return {
        wood: a.wood + (b.wood ?? 0),
        clay: a.clay + (b.clay ?? 0),
        iron: a.iron + (b.iron ?? 0),
        grain: a.grain + (b.grain ?? 0),
    };
}
export function subtractResources(a, b) {
    return {
        wood: a.wood - (b.wood ?? 0),
        clay: a.clay - (b.clay ?? 0),
        iron: a.iron - (b.iron ?? 0),
        grain: a.grain - (b.grain ?? 0),
    };
}
export function scaleResources(a, factor) {
    return {
        wood: (a.wood ?? 0) * factor,
        clay: (a.clay ?? 0) * factor,
        iron: (a.iron ?? 0) * factor,
        grain: (a.grain ?? 0) * factor,
    };
}
export function floorResources(a) {
    return {
        wood: Math.floor(a.wood),
        clay: Math.floor(a.clay),
        iron: Math.floor(a.iron),
        grain: Math.floor(a.grain),
    };
}
/** True when `have` covers every entry in `cost`. */
export function canAfford(have, cost) {
    return RESOURCE_KEYS.every((key) => have[key] >= (cost[key] ?? 0));
}
/** Which resources are short, and by how much. Empty object when affordable. */
export function shortfall(have, cost) {
    const missing = {};
    for (const key of RESOURCE_KEYS) {
        const need = (cost[key] ?? 0) - have[key];
        if (need > 0)
            missing[key] = Math.ceil(need);
    }
    return missing;
}
export function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
}
/** Euclidean distance in map tiles. */
export function tileDistance(a, b) {
    return Math.hypot(a.x - b.x, a.y - b.y);
}
//# sourceMappingURL=common.js.map